import * as React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSelector } from 'react-redux';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

dayjs.extend(utc);
dayjs.extend(timezone);

const InputDateUTC = ({
  clearable = false,
  id,
  label,
  name,
  placeholder,
  value,
  error,
  onBlur,
  onChange,
  disabled,
  maxDate,
  minDate,
  format = 'DD/MMM/YYYY',
  isStartOfTheDay = true,
  helperText,
  size,
  variant = 'standard',
  type
}) => {
  const timezone = useSelector((state) => state.tenant?.timezone || 'Australia/Victoria');

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        id={id}
        label={label}
        name={name}
        placeholder={placeholder}
        value={value ? dayjs(value).tz(timezone) : null} // Display date in user's timezone
        disabled={disabled}
        format={format || 'DD/MMM/YYYY'}
        onChange={(selectedDate) => {
          if (!selectedDate) {
            onChange(null);
            return;
          }
          const selectedDateWithZeroTime = isStartOfTheDay ?  dayjs(selectedDate).startOf('day') : dayjs(selectedDate).endOf('day');
          const utcDate = selectedDateWithZeroTime.tz(timezone).utc();
          onChange(utcDate.toISOString());
        }}
        onBlur={onBlur}
        timezone={timezone}
        slotProps={{
          textField: {
            variant,
            error,
            helperText: helperText,
            fullWidth: true,
            disabled,
            size,
          },
          field: {
            clearable,
            onClear: () => onChange(null)
          }
        }}
        maxDate={maxDate ? dayjs(maxDate).tz(timezone) : undefined}
        minDate={minDate ? dayjs(minDate).tz(timezone) : undefined}
      />
    </LocalizationProvider>
  );
};

export default InputDateUTC;
